<template>
  <div :class="['pre-loader', { show: isVisible }]">
    <div class="pre-loader__block">
      <div class="spinner spinner-1" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BasePreloader',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isVisible: false
      }
    },
    watch: {
      show (newVal) {
        if (newVal) {
          this.isVisible = true
        } else {
          setTimeout(() => {
            this.isVisible = false
          }, 300)
        }
      }
    },
    mounted () {
      if (this.show) this.isVisible = true
    }
  }
</script>

<style lang="scss">
.pre-loader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;

  &.show {
    opacity: 1;
    visibility: visible;
  }
}

.pre-loader__block {
  display: flex;
  justify-content: center;
}

.spinner {
  position: relative;
  width: 3.5em;
  height: 3.5em;
}

.spinner::before,
.spinner::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  content: "";
  border-style: solid;
  border-width: 0.12em;
  border-radius: 50%;
}

@keyframes rotate-animation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes anti-rotate-animation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(-360deg); }
}

.spinner.spinner-1::before {
  width: 100%;
  height: 100%;
  border-top-color: transparent;
  border-right-color: currentColor;
  border-bottom-color: currentColor;
  border-left-color: transparent;
  animation: rotate-animation 1s linear infinite;
}

.spinner.spinner-1::after {
  width: 80%;
  height: 80%;
  border-top-color: transparent;
  border-right-color: currentColor;
  border-bottom-color: currentColor;
  border-left-color: transparent;
  animation: anti-rotate-animation 0.85s linear infinite;
}
</style>
